import type { SVGProps } from 'react'

type Props = SVGProps<SVGSVGElement> & {
  kind:
    | 'coupon'
    | 'lucky_number'
    | 'pix'
    | 'none'
    | 'sound'
    | 'muted'
    | 'share'
    | 'gift'
    | 'arrow'
}

/** Inline artwork keeps the wheel and its controls independent of icon downloads. */
export function RouletteIcon({ kind, ...props }: Props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {kind === 'coupon' && (
        <>
          <path d="M4 5h16v5a2 2 0 0 0 0 4v5H4v-5a2 2 0 0 0 0-4Z" />
          <path d="m9 15 6-6" />
          <circle cx="9" cy="9" r=".8" />
          <circle cx="15" cy="15" r=".8" />
        </>
      )}
      {kind === 'lucky_number' && (
        <>
          <rect x="4" y="5" width="16" height="15" rx="3" />
          <path d="m10 8-1 9m6-9-1 9M7 11h10M7 14h10M8 2h8" />
        </>
      )}
      {kind === 'pix' && (
        <>
          <path
            d="m12 2 4.5 4.5L12 11 7.5 6.5Zm10 10-4.5 4.5L13 12l4.5-4.5ZM12 22l-4.5-4.5L12 13l4.5 4.5ZM2 12l4.5-4.5L11 12l-4.5 4.5Z"
            strokeWidth="1.3"
          />
        </>
      )}
      {kind === 'none' && (
        <>
          <path d="m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5Z" />
          <path d="m19 3 .5 1.5L21 5l-1.5.5L19 7l-.5-1.5L17 5l1.5-.5Z" strokeWidth="1" />
        </>
      )}
      {(kind === 'sound' || kind === 'muted') && (
        <>
          <path d="M11 4 6 8H3v8h3l5 4Z" />
          {kind === 'sound' ? (
            <>
              <path d="M15 8a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14" />
            </>
          ) : (
            <path d="m16 9 5 6m0-6-5 6" />
          )}
        </>
      )}
      {kind === 'share' && (
        <>
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <path d="m8.6 10.5 6.8-4m-6.8 7 6.8 4" />
        </>
      )}
      {kind === 'gift' && (
        <>
          <path d="M4 11h16v10H4ZM3 7h18v4H3ZM12 7v14" />
          <path d="M12 7C5 8 4 2 7 2c3 0 5 5 5 5Zm0 0c7 1 8-5 5-5-3 0-5 5-5 5Z" />
        </>
      )}
      {kind === 'arrow' && <path d="M5 12h14m-6-6 6 6-6 6" />}
    </svg>
  )
}
